import React from 'react';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import styled from 'styled-components';

import { ButtonCustom, Text, localeEmptyTable } from 'components';
import { ButtonType } from 'components/Antd/Button';
// import { DetailSection, BookingCode, TimeText, TypeText } from '../styles';
import { ColumnHeader } from 'styles/shareStyles';
import { formatDepartureTime, getPaymentStatus } from 'utils';
import {
    BookingStatus,
    JetInfo,
    FlightInfo,
    Booker,
    PaymentStatus,
    FlightStatus
} from 'components/Commons';
import { FLIGHT_DETAIL, FLIGHT_LIST } from 'routes/main';

const UpComingFlightTable = (props) => {
    const {
        navigate,
        list = {},
        key,
        setKey,
        loading = false,
        onChangePageUpcomingFlights
    } = props;
    const { docs = [], limit, page, pages, total = 1 } = list;
    const haveData = docs.length ? true : false;
    const { t, i18n } = useTranslation();

    const onClickUpcomingFlight = () => {
        navigate(FLIGHT_LIST);
    };

    const columns = [
        {
            title: function titleHeader() {
                return <ColumnHeader>{t('FLIGHTS') + ' #'}</ColumnHeader>;
            },
            width: '15%',
            dataIndex: 'flight_code',
            key: 'flight_code',
            render: function eachItemFlight(flight_code) {
                return <BookingCode>{flight_code}</BookingCode>;
            }
        },
        {
            title: function titleHeader() {
                return <ColumnHeader>{t('DEPARTURE_TIME')}</ColumnHeader>;
            },
            width: '30%',
            dataIndex: 'departure',
            key: 'departure',
            render: function eachItemDepartureTime(departure) {
                const { date = '', time = '', utc_offset = 0 } = departure;
                return (
                    <TimeText>
                        {formatDepartureTime(date, time, utc_offset)}
                    </TimeText>
                );
            }
        },

        {
            title: function titleHeader() {
                return <ColumnHeader>{t('FLIGHT_INFO')}</ColumnHeader>;
            },
            dataIndex: 'from_to',
            key: 'from_to',
            width: '30%',
            render: function eachItemFromTo(from_to, record) {
                const leg = {
                    from_airport: record.from_airport || {},
                    to_airport: record.to_airport || {}
                };
                return (
                    <div>
                        <FlightInfo leg={leg} />
                    </div>
                );
            }
        },

        {
            title: function titleHeader() {
                return <ColumnHeader>{t('JET_INFO')}</ColumnHeader>;
            },
            dataIndex: 'aircraft',
            key: 'aircraft',
            width: '15%',
            render: function eachItemJetInfo(aircraft) {
                const leg = { aircraft: aircraft };

                return (
                    <div>
                        <JetInfo leg={leg} vertical={true} />
                    </div>
                );
            }
        },

        {
            key: 'action',
            width: '15%',
            render: function setAction(val) {
                return (
                    <DetailSection>
                        <ButtonCustom
                            btnType={ButtonType.SECONDARY}
                            title={t('DETAILS').toUpperCase()}
                            size="small"
                            borderColor="1px solid rgba(18, 18, 22, 0.2)"
                            width="86px"
                            onClick={(e) => navigate(FLIGHT_DETAIL, val.id)}
                        />
                    </DetailSection>
                );
            }
        }
    ];

    return (
        <TableContainer haveData={haveData}>
            <TableHeader>
                <Text textStyle="heading5">{`${t(
                    'UPCOMING_FLIGHTS'
                ).toUpperCase()} (${total})`}</Text>
                <ViewAllButton onClick={onClickUpcomingFlight}>
                    <Text textStyle="upload">
                        {t('VIEW_ALL').toUpperCase()}
                    </Text>
                </ViewAllButton>
            </TableHeader>
            <Table
                columns={columns}
                dataSource={docs}
                style={{ marginTop: 20 }}
                scroll={{ x: 620 }}
                loading={loading}
                pagination={false}
                locale={localeEmptyTable()}
                // pagination={{
                //     defaultPageSize: 5,
                //     total: pages * 5 - 1,
                //     hideOnSinglePage: false,
                //     showSizeChanger: false
                // }}
                // onChange={(e) => onChangePageUpcomingFlights(e)}
            />
        </TableContainer>
    );
};

export default UpComingFlightTable;

const TableContainer = styled.div`
    @media (min-width: 1025px) {
        .ant-table {
            height: 440px;
        }
        .ant-table-content {
            height: 440px;
        }
    }
    .ant-table-tbody > tr > td {
        border-bottom: ${(props) =>
            props.haveData ? '1px solid #f0f0f0' : '0px'};
    }
`;

const ViewAllButton = styled.button`
    border: none;
    background-color: transparent;
    cursor: pointer;
`;

const TableHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const DetailSection = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-right: 5px;
`;

const BookingCode = styled.span`
    color: #121216;
    font-family: AvenirNext-DemiBold;
    font-size: 11px;
    letter-spacing: 0.88px;
    line-height: 13px;
    text-align: left;
`;

const TimeText = styled.span`
    color: #65686f;
    font-family: AvenirNext-Medium;
    font-size: 11px;
    line-height: 18px;
    width: 147px;
    text-align: left;
`;
